// TOTP codes from pyotp default to 6 digits (backend: app/api/auth.py).
export const OTP_LENGTH = 6;
// Backup codes are generated as `randbelow(900000) + 100000` so they are
// always exactly 6 numeric digits (backend: app/api/auth.py:1067).
export const BACKUP_CODE_LENGTH = 6;
// Switch to backup-code entry after this many failed OTP attempts.
// The backend's 5/min rate limit on /auth/2mfa/verify is the authoritative
// lockout; this counter is UX-only.
export const OTP_FAILURE_LIMIT = 3;
